import React, { FC } from 'react';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './NotFound.module.css';

interface NotFoundProps {}

const NotFound: FC<NotFoundProps> = () => (
  <div className={`flex flex-col justify-between h-screen`} data-testid="NotFound">
    <Header />
    <div className={`${styles.body} flex w-full justify-center align-center position-ref full-height`}>
      <span className={styles.code}>404</span>
      <span className={styles.message}>Not found</span>
    </div>
    <Footer />
  </div>
);

export default NotFound;
